import { Dropdown, Stack, TextField } from '@fluentui/react';
import { getAPI } from 'caccl/client';
import React, { useEffect, useState } from 'react';

type IMethod = "GET" | "PUT" | "DELETE" | "POST" | undefined

const CrudTester: React.FunctionComponent = () => {

  const [apiUrl, setApiUrl] = useState<string>();
  const [body, setBody] = useState<any>();
  const [method, setMethod] = useState<IMethod>("GET");
  const [params, setParams] = useState<{[k: string]: any}>()

  useEffect(() => {
    getAPI().then((api) => {
        
        api.other.endpoint({
            path: `/api/v1/${apiUrl}`,
            method: method,
            params: params
        }).then((data: any[]) => {
            setBody(data);
        }).catch(err => {
            setBody(err);
        })
       
    });

  },[apiUrl, method])

  const apiMethods = ["GET"]

  return (
    <Stack tokens={{childrenGap: 10}}>
        <TextField label='API URL' onChange={(_, newValue) => {
            const str = newValue || "";
            const path = str.split("?")[0];
            const paramStr = str.split("?")[1];
            let params: any = {};
            if(paramStr)
            {
                paramStr.split("&").forEach(v => {
                    const key = v.split("=")[0];
                    const value = v.split("=")[1];
                    params[key] = value;
                })
            }
            setApiUrl(path);
            setParams(params);
        }} />
        <Dropdown label='Method' options={apiMethods.map(m => ({key: m, text: m}))} selectedKey={method} onChange={(_, option) => setMethod(option?.key?.toString() as IMethod || "GET")} />
       
        <TextField rows={60} readOnly multiline value={JSON.stringify(body, null, "\t")} />
    </Stack>
  );
}

export default CrudTester;
